import MachineList from './MachineList/MachineList'

export default {
  MachineList,
}
